var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:`svg ${_vm.icon}`,domProps:{"innerHTML":_vm._s(require(`!html-loader!../assets/svg/${_vm.icon}.svg`))}})
}
var staticRenderFns = []

export { render, staticRenderFns }